module.exports = __webpack_public_path__ + "static/media/Email.a62c2875.png";